<template>
  <div class="container">
        <a-modal class="gufiiguy" :title="titleList[type-1]" :visible="recordsDetailVisible"  @cancel="closeRecordsDetail"  width="70%"  > 
             <template slot="footer" >
      <a-button key="back" @click="closeRecordsDetail"> 取消 </a-button>
    </template>
             <a-form-model :model="tableList" :rules="rules" ref="recordsForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">    
                 <div class="center">
                      <a-row>
                           <a-col :span="12">
                                <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18 }"
                                 label="公司名称"  prop="">
                                   <span>{{ tableList.companyName}}</span>
                                </a-form-model-item>
                           </a-col>
                           <a-col :span="12">
                                <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18 }"
                                 label="检测项目"  prop="">
                                   <span>{{ tableList.subName}}</span>
                                </a-form-model-item>
                           </a-col>
                      </a-row>
                        <a-row>
                           <a-col :span="12">
                                <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18 }"
                                 label="检测费合计"  prop="">
                                   <span>{{ tableList.total}}</span>
                                </a-form-model-item>
                           </a-col>
                      </a-row>
                      <div class="body"  style="margin-bottom: 10px; height: calc(100% - 126px)" ref="mainTable" id="content_main_center_scroll">
                          	<a-table v-if="type == 1" :columns="columns1" :data-source="tableList.list" :scroll="{ y: scroll_y }" bordered :pagination="false">
				                  	</a-table>
                            <a-table v-if="type == 2 || type == 3" :columns="columns2" :data-source="tableList.list" :scroll="{ y: scroll_y }" bordered :pagination="false">
				                  	</a-table>
                            <a-table v-if="type == 4" :columns="columns3" :data-source="tableList.list" :scroll="{ y: scroll_y }" bordered :pagination="false">
				                  	</a-table>
					                	<!-- <a-button class="back" key="back" @click="closeRecordsDetail"> 取消 </a-button> -->
                      </div>
                 </div>
             </a-form-model>
             
                 


        </a-modal>
  </div>
</template>

<script>
export default {
    props: [
        'recordsDetailVisible',
        'tableList',
        'type'

    ],
    data() {
        return {
          scroll_y: 150,
          titleList:[
            '报价记录-检测费用明细(职卫)',
            '报价记录-检测费用明细(环境检测、环境咨询)',
            '报价记录-检测费用明细(环境检测、环境咨询)',
           '报价记录-检测费用明细(公卫)',
          ],
            harmfulData: [{
                industryName: '',
            }],
        // recordsDetailVisible: false,
        columns1: [
             {
    title: '岗位名称',
    dataIndex: 'postName',
    key: 'postName',
    ellipsis: true,
  },
  {
    title: '检测项目',
    dataIndex: 'item',
    key: 'item',
    ellipsis: true,
  },
  {
    title: '点位数',
    dataIndex: 'pointNumber',
    key: 'pointNumber',
    ellipsis: true,
  },
   {
    title: '单价',
    dataIndex: 'price',
    key: 'price',
    ellipsis: true,
  },
   {
    title: '小计',
    dataIndex: 'totalPrice',
    key: 'totalPrice',
    ellipsis: true,
  },
],
    columns2: [
             {
    title: '检测点位',
    dataIndex: 'pointName',
    key: 'pointName',
    ellipsis: true,
  },
  {
    title: '检测项目',
    dataIndex: 'item',
    key: 'item',
    ellipsis: true,
  },
    {
    title: '频次',
    dataIndex: 'frequence',
    key: 'frequence',
    ellipsis: true,
  },
  {
    title: '点位数（个）',
    dataIndex: 'pointNumber',
    key: 'pointNumber',
    ellipsis: true,
  },
   {
    title: '样品数（个）',
    dataIndex: 'sampleNumber',
    key: 'sampleNumber',
    ellipsis: true,
  },
   {
    title: '单价',
    dataIndex: 'price',
    key: 'price',
    ellipsis: true,
  },
   {
    title: '小计',
    dataIndex: 'totalPrice',
    key: 'totalPrice',
    ellipsis: true,
  },
],
    columns3: [

  {
    title: '检测项目',
    dataIndex: 'item',
    key: 'item',
    ellipsis: true,
  },
  {
    title: '点位数量（个）',
    dataIndex: 'pointNumber',
    key: 'pointNumber',
    ellipsis: true,
  },
   {
    title: '单价',
    dataIndex: 'price',
    key: 'price',
    ellipsis: true,
  },
   {
    title: '小计',
    dataIndex: 'totalPrice',
    key: 'totalPrice',
    ellipsis: true,
  },
]


        }
    },
    mounted() {
    //     this.$nextTick((res) => {
    //   this.scroll_y = this.$refs.mainTable.offsetHeight - 54
    // })
    this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
				setTimeout(() => {
					this.scroll_y = max_h - $(".ant-table-header").height() - 50;
				}, 1000);
			})

    },
    methods: {
        closeRecordsDetail() {
            this.recordsDetailVisible = false
            this.$emit('closeVisible', this.recordsDetailVisible)
        }
    }

}
</script>

<style>
.back {
 width: 100px;
  margin-top: 20px ;
  margin-left: 92%;
  /* float: right; */
}

</style>